import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function Menu() {
  const [menuItems, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [menuPdf, setMenuPdf] = useState(null);
  const [galleryItems, setGalleryItems] = useState([]);

  useEffect(() => {
    apiService.getMenuItems()
      .then(response => setMenuItems(response.data.items))
      .catch(error => console.error('Error loading menu items:', error));

    apiService.getMenuCategories()
      .then(response => setCategories(response.data.categories))
      .catch(error => console.error('Error loading categories:', error));

    apiService.getMenuPdf()
      .then(response => setMenuPdf(response.data.menu_pdf))
      .catch(error => console.error('Error loading menu PDF:', error));

    apiService.getGallery()
      .then(response => setGalleryItems(response.data.gallery))
      .catch(error => console.error('Error loading gallery:', error));
  }, []);

  const getItemsByCategory = (categoryId) => {
    return menuItems.filter(item => item.category_id === categoryId);
  };

  return (
    <div className="menu-page">
      <section 
        className="hero-section" 
        style={{
          backgroundImage: galleryItems.filter(item => item.file_type === 'image').length > 0 
            ? `url(${galleryItems.filter(item => item.file_type === 'image')[0]?.file_path})` 
            : 'none',
          height: '60vh'
        }}
      >
        <div className="hero-content">
          <h1 className="hero-title">OUR MENU</h1>
        </div>
      </section>

      {menuPdf && (
        <section className="section section-light" style={{paddingTop: '40px', paddingBottom: '40px'}}>
          <div className="container" style={{textAlign: 'center'}}>
            <h2 className="section-title" style={{color: 'var(--primary-blue)', marginBottom: '30px'}}>
              Download Our Menu
            </h2>
            <div style={{display: 'inline-flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center'}}>
              <a 
                href={menuPdf.file_path} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  padding: '15px 30px',
                  backgroundColor: 'var(--primary-blue)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontWeight: '600',
                  display: 'inline-block',
                  transition: 'background-color 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#1e6a8f'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--primary-blue)'}
              >
                View PDF
              </a>
              <a 
                href={menuPdf.file_path} 
                download={menuPdf.file_name}
                style={{
                  padding: '15px 30px',
                  backgroundColor: 'transparent',
                  color: 'var(--primary-blue)',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontWeight: '600',
                  display: 'inline-block',
                  border: '2px solid var(--primary-blue)',
                  transition: 'background-color 0.3s, color 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--primary-blue)';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = 'var(--primary-blue)';
                }}
              >
                Download PDF
              </a>
            </div>
          </div>
        </section>
      )}

      <section className="section section-light">
        <div className="container">
          {categories.map(category => {
            const items = getItemsByCategory(category.id);
            if (items.length === 0) return null;

            return (
              <div key={category.id} style={{marginBottom: '60px'}}>
                <h2 className="section-title" style={{color: 'var(--primary-blue)', marginBottom: '30px'}}>
                  {category.name}
                </h2>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '30px'}}>
                  {items.map(item => (
                    <div key={item.id} className="menu-item" style={{borderBottom: '1px solid #eee', paddingBottom: '20px'}}>
                      {item.image_url && (
                        <img src={item.image_url} alt={item.name} style={{width: '100%', height: '200px', objectFit: 'cover', marginBottom: '15px'}} />
                      )}
                      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start'}}>
                        <div>
                          <h3 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px'}}>{item.name}</h3>
                          <p style={{color: '#666', fontSize: '0.9rem'}}>{item.description}</p>
                        </div>
                        {item.price && (
                          <span style={{fontSize: '1.1rem', fontWeight: '600', color: 'var(--primary-blue)'}}>
                            ${item.price}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default Menu;
